import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import NProgress from 'nprogress';
import {
    $http,
    MAP_LIST
} from '$http';
// 新增 编辑
export default {
    mixins: [services],
    data() {
        return {
            AddDialogVisible: false,
            loading: false,
            title: '',
            form: this.getFollowData(),
            classList: [],
            OptionTypes: [],
            CheckResult: [],
            objectName: ''

        }
    },
    methods: {
        getFollowData() {
            return cloneDeep({
                "NetCheckId": 0,
                "OptionId": '',
                "CheckResultId": '',
                "Remark": ""
            })
        },
        changeModal(val) {
            if (val !== '') {
                this.form.CheckResultId = ''
                this.GetOptionDetailByOptionId(val)
            }

        },
        show(opts) {
            this.form = this.getFollowData()
            this.AddDialogVisible = true
            this.title = opts.title
            this.form.NetCheckId = opts.Id
            if (opts.objectName) {
                this.objectName = opts.objectName
            }

            this.GetOptionByModId(opts.ModuleId)
        },
        // 提交
        submit() {
            // 判断
            let flag = util.checkForm({
                ele: this,
                rules: [{
                    name: "检测进度",
                    value: this.form.OptionId,
                    required: true,
                }, {
                    name: "检测结果",
                    value: this.form.CheckResultId,
                    required: true,
                }]
            });
            if (!flag) {
                return false;
            }
            this.AddNetCheckFollow()

        },
        //取消
        close() {
            this.AddDialogVisible = false
        }

    },
}


// WEBPACK FOOTER //
// ./src/pages/Network/networkCheck/components/followDialog/vm.js